import { render, staticRenderFns } from "./UserAvatarIndicator.vue?vue&type=template&id=8deaaae0&scoped=true"
import script from "./UserAvatarIndicator.vue?vue&type=script&lang=js"
export * from "./UserAvatarIndicator.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarIndicator.vue?vue&type=style&index=0&id=8deaaae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deaaae0",
  null
  
)

export default component.exports